module.exports = __webpack_public_path__ + "static/media/cuentas.529ae633.svg";